import { FC } from "react";
import PasswordDescription from "./PasswordDescription";
import { Box, List, Flex } from "@chakra-ui/react";
import { CheckCircleIcon, WarningIcon } from "@chakra-ui/icons";
import { borderColor, errorColor, successColor } from "../../../utils/colors";

interface PasswordDefinitionProps {
  password: string;
  passwordDescriptions: string[];
  passwordRules: RegExp[];
  barColors: string[];
}

const PasswordStrengthBarComponent: FC<PasswordDefinitionProps> = ({
  password,
  passwordDescriptions,
  passwordRules,
  barColors,
}) => {
  const ruleStatuses = passwordRules.map((rule) => rule.test(password));
  const satisfiedRuleCount = ruleStatuses.filter(
    (isSatisfied) => isSatisfied,
  ).length;

  const filledNumberOfBars =
    satisfiedRuleCount === 0
      ? 0
      : Math.max(
          1,
          Math.floor(
            (satisfiedRuleCount * barColors.length) / passwordRules.length,
          ),
        );

  const filledBarColor =
    filledNumberOfBars > 0 ? barColors[filledNumberOfBars - 1] : "white";

  return (
    <List spacing={1}>
      <Flex alignItems="center" gap="1">
        {barColors.map((_, index) => (
          <Box
            key={index}
            height="7px"
            width="52px"
            backgroundColor={
              index < filledNumberOfBars ? filledBarColor : "white"
            }
            border="1px solid"
            borderColor={borderColor}
            transition="background-color 0.3s ease"
          />
        ))}
      </Flex>
      {passwordDescriptions.map((description, index) => (
        <PasswordDescription
          key={index}
          description={description}
          color={ruleStatuses[index] ? successColor : errorColor}
          icon={
            ruleStatuses[index] ? (
              <CheckCircleIcon color={successColor} boxSize={4} />
            ) : (
              <WarningIcon color={errorColor} boxSize={4} />
            )
          }
        />
      ))}
    </List>
  );
};

export default PasswordStrengthBarComponent;
